<div class="main-container-article text">
  <app-payment-response-error-success
    [resultStatus]="statu === '1' ? 'success' : 'error'"
    [message]="(statu === '1' ? 'Withdraw_Successful_Desc' : 'errorcode500') | translate"
    [actionText]="'Continue' | translate"></app-payment-response-error-success>
</div>
